import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";

export default function Idle_PopUp({
  IdlePopUp,
  setIdlePopUp,
  listData,
  trigger,
  setTrigger,
}) {
  const dropDown = ["IDLE"];
  const [dropdown, setDropDown] = useState("");
  const [loading, setLoading] = useState();
  const handleDropChange = (e) => {
    setDropDown(e.target.value);
  };
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");

  const onSubmit = async () => {
    if (dropdown === "") {
      dispatch(
        setAppError({
          msg: "Demobilization type is required.",
        })
      );
      return;
    }
    try {
      let MappedData = listData.map((data, index) => {
        return {
          employee_id: data.candidate_id,
          demobilization_type: dropdown,
        };
      });
      console.log("reqObject to be printed in the console", MappedData);
      const response = await nodeinstance.put(
        `/idleStatus/RemobilizeIdle`,
        MappedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setIdlePopUp(false);
        setTrigger(!trigger);
      }
    } catch (error) {
      console.log("error.........", error);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          IdlePopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-xl w-full max-h-[40rem] min-h-[15rem] overflow-y-scroll overflow-x-hidden rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setIdlePopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md flex-grow mt-5">
            <label htmlFor={`addOrEdit-name`} className="text-xs">
              CHANGE STATUS
            </label>
            <select
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              onChange={(e) => {
                handleDropChange(e);
              }}
            >
              <option value="">SELECT STATUS</option>
              {dropDown.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full flex flex-col gap-3 my-3 p-5">
            <div className="flex gap-3 w-full justify-center">
              <button
                className="p-3 bg-red text-white rounded-md w-full max-w-xs my-4 flex gap-3 justify-center items-center text-sm"
                onClick={() => {
                  onSubmit();
                }}
              >
                <p>Submit</p>
                {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
